<template>
  <div class="px-[24px] h-screen flex flex-col justify-center">
    <div class="">
      <CheckCircleIcon class="mx-auto" />

      <StrongTitle class="mt-5">
        {{ $t('password_changed_title') }}
      </StrongTitle>

      <div class="mt-5 text-center">
        {{ $t('password_changed_text') }}
      </div>

      <BaseButton
        class="mt-5"
        @click="goToLogin"
      >
        {{ $t('password_change_login') }}
      </BaseButton>
    </div>
  </div>
</template>

<script setup>
import BaseButton from '@/components/buttons/BaseButton.vue'
import StrongTitle from '@/components/ui/StrongTitle.vue'
import CheckCircleIcon from '@/assets/icons/CheckCircleIcon.vue'
import { useRouter } from 'vue-router'
import { ROUTE_NAMES } from '@/router'

const router = useRouter()

const goToLogin = () => router.push({ name: ROUTE_NAMES.LOGIN })
</script>
